import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			display: 'flex',
			flexDirection: 'row',
			margin: '10px 0px',
		},
		formControl: {
			flex: '1',
			margin: '0px 8px',
			height: '40px',
		},
		select: {
			padding: '0 10px',
			height: 40,
		},
		active: {
			color: theme.palette.text.secondary,
			borderBottom: `2px solid ${theme.palette.text.secondary}`,
		},
		link: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			padding: '10px 4px',
			textDecoration: 'unset',
			flex: 1,
		},
		resultsCount: {
			display: 'flex',
			fontSize: "12px",
			color: "#bababa"
		}
	})
